export default __webpack_public_path__ + "static/media/wave_blue.26ffd552.svg";